import React from "react"
import { useIntl } from "gatsby-plugin-intl"
import FontAwesome from 'react-fontawesome'
import { Form, Row } from "react-bootstrap"

const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const FooterForm = (): JSX.Element => {
  const [email, setEmail] = React.useState('')
  const intl = useIntl()

  const handleSubmit = (e) => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "footer-email-form",
        ...{ email },
      }),
    })
    setEmail("")
    e.preventDefault()
  }

  const onChange = (e) => setEmail(e.target.value)

  return (
    <Form
      onSubmit={handleSubmit}
      id="footer-email-form"
      name="footer-email-form"
      data-netlify="true"
      method="post"
    >
      <Row>
        <Form.Control
          type="email"
          name="email"
          maxLength={256}
          className="footer-form-field dark px-4 py-2"
          onChange={onChange}
          value={email || ""}
          placeholder={intl.formatMessage({ id: 'contact.email' })}
        />
        <button className="footer-form-button px-3" type="submit">
          <FontAwesome className="social-icon" name="arrow-right" />
        </button>
      </Row>
    </Form>
  )
}

export default FooterForm
